import { render, staticRenderFns } from "./DetailsMonitoringZone.vue?vue&type=template&id=47522ff5&"
import script from "./DetailsMonitoringZone.vue?vue&type=script&lang=js&"
export * from "./DetailsMonitoringZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports